/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取订单列表数量
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class AddRedisKeyValueParams {
  constructor(public key?: string, public value?: string) {}
}

export default async function (
  params: AddRedisKeyValueParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/order/redis/set`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
